import { Box } from "@chakra-ui/react";
import { useOverlay } from "@toss/use-overlay";
import {
  ColorIcon,
  colors,
  customEvent,
  HStack,
  OverlayModal,
  useResponsive,
  VStack,
} from "goi_common";
import React from "react";

export function useRecathModal() {
  const overlay = useOverlay();
  const { isBiggerThanMd } = useResponsive();

  const openServiceDownloadModal = () => {
    overlay.open(({ isOpen, close: onClose }) => (
      <OverlayModal
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick
        modalContentStyle={{
          minWidth: isBiggerThanMd ? "500px" : "90%",
          borderRadius: "10px",
          overflow: "hidden",
        }}
        overlayModalContent={<MaintenanceNoticeModal onClose={onClose} />}
      />
    ));
  };

  const openModal = () => {
    customEvent({ newGtm: { action: "consult-button-click" } });
    overlay.open(({ isOpen, close: onClose }) => (
      <OverlayModal
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick
        modalContentStyle={{
          minWidth: isBiggerThanMd ? "500px" : "90%",
          borderRadius: "10px",
          overflow: "hidden",
        }}
        overlayModalContent={<MaintenanceNoticeModal onClose={onClose} />}
      />
    ));
  };

  return { openModal, openServiceDownloadModal };
}

function MaintenanceNoticeModal({ onClose }: { onClose: () => void }) {
  return (
    <VStack
      width="100%"
      background="white"
      padding="32px 24px"
      gap={24}
      alignItems="center"
    >
      <HStack justifyContent="flex-end" width="100%">
        <Box onClick={onClose} style={{ cursor: "pointer" }}>
          <ColorIcon name="icon-x-mono" color={colors.gray500} size={24} />
        </Box>
      </HStack>
      <ColorIcon name="icon-check-mono" color={colors.orange650} size={48} />
      <VStack alignItems="center" gap={8}>
        <Box className="subtitle_21_b" textAlign="center">
          운영 정비 안내
        </Box>
        <Box
          className="body_16_m"
          textAlign="center"
          color={colors.gray600}
        >
          현재 운영 정비기간으로
          <br />
          신규 제휴를 받고 있지 않습니다.
          <br />
          이용에 불편을 드려 죄송합니다.
        </Box>
      </VStack>
      <button
        type="button"
        onClick={onClose}
        style={{
          width: "100%",
          background: colors.orange650,
          color: "white",
          borderRadius: "10px",
          padding: "12px 16px",
          fontSize: "16px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        확인
      </button>
    </VStack>
  );
}
